/**
 * MultiColumnAccordion Module
 * Has sub elements of the same width, each with a content to expand.
 * The content will expand below the row, the element to expand is in.
 *
 * Use following html markup:
 * <div class="bs-row multi-column-accordion-element">
 *     <div class="bs-col-{n} multi-column-accordion-element">
 *         <div>{HEADER CONTENT}</div>
 *         <div class="multi-column-accordion-element-content">
 *             <div class="multi-column-accordion-element-content-inner">
 *                 {ACCORDION ELEMENT CONTENT}
 *             </div>
 *         </div>
 *     </div>
 *     [...]
 * </div>
 */

class MultiColumnAccordion
{
    /**
     * @param {jQuery} $modAccordion
     */
    constructor($modAccordion)
    {
        this.$accordion = $modAccordion;
        this.$accordion.data('MultiColumnAccordion', this);
        this.$expandable = null;

        this.$accordion.addClass('multi-column-accordion-enabled');
        this.$accordion.on('click', '.multi-column-accordion-element', {parent: this}, function(e) {
            let $this = $(this);
            e.preventDefault();
            if ($this.hasClass('active')) {
                e.data.parent.closeOpen($this);
            } else {
                e.data.parent.openElement($this);
            }
        });
        this.$accordion.on('click', '.multi-column-accordion-element-close-indicator', {parent: this}, function(e) {
            e.preventDefault();
            e.data.parent.closeOpen();
        });
        $(window).on('resize', null, {accordion: this}, function(e) {
            e.data.accordion.closeOpen();
        })
    }

    /**
     * Calculates and returns the currently open accordion element.
     * Expects all accordion elements to have the same width!
     * @param {jQuery} $element
     * @returns {jQuery|HTMLElement}
     */
    getExpandPosition($element) {
        let ratio = this._getRowElementsCount($element);
        let $allElements = this.$accordion.find('.multi-column-accordion-element');
        let lastInRowIndex = $allElements.index($element);
        while((lastInRowIndex + 1) % ratio !== 0) {
            lastInRowIndex++;
        }
        let lastInRow = $allElements[lastInRowIndex];
        while (typeof lastInRow === 'undefined') {
            lastInRowIndex--;
            lastInRow = $allElements[lastInRowIndex];
        }

        return $(lastInRow);
    }

    /**
     * Closes the currently open accordion element (if any) and opens $element
     * @param {jQuery} $element
     * @returns {boolean}
     */
    openElement($element) {
        this.closeOpen();
        this.$accordion.addClass('expanded');

        $element.addClass('active');

        let $content = $element.find('.multi-column-accordion-element-content .multi-column-accordion-element-content-inner');
        let $expandAfter = this.getExpandPosition($element);
        let $expandable = $("<div class=\"multi-column-accordion-expandable bs-col-12\"></div>");
        $content.clone().appendTo($expandable);
        $expandable.insertAfter($expandAfter);
        this.$expandable = $expandable;

        let $sameRowElements = this.$expandable.prevAll().slice(0, this._getRowElementsCount($element)).filter(':not(.active)');
        $sameRowElements.addClass('active-same-row');

        TweenLite.from($expandable, 1,
            { height:0, autoAlpha:0, ease:Power2.easeInOut });

        return true;
    }

    /**
     * Closes the currently opened accordion element
     */
    closeOpen() {
        this.$accordion.removeClass('expanded');
        let $activeElement = this.$accordion.find('.multi-column-accordion-element.active');
        let $currentExpandable = this.$expandable;
        let $sameRowElements = this.$accordion.find('.multi-column-accordion-element.active-same-row');
        if ($activeElement.length) {
            $activeElement.removeClass('active');
            $sameRowElements.removeClass('active-same-row');
            TweenLite.to($currentExpandable, 1, { height:0, autoAlpha:0, ease:Power2.easeInOut, onComplete: function($expandable, $activeElement) {
                $expandable.remove();
            }, onCompleteParams: [$currentExpandable, $activeElement] });
            TweenLite.to($activeElement, 1, {ease:Power2.easeInOut});
        }
    }

    _getRowElementsCount($element) {
        return Math.round(this.$accordion.width() / $element.width());
    }
}